import * as React from 'react';
import {useEffect, useState} from "react";
import cx from "classnames";

import Modal from '@mui/material/Modal';

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Step1 from "../../../static/images/steps/Step1.jpg";
import Step2 from "../../../static/images/steps/Step2.jpg";
import Step3 from "../../../static/images/steps/Step3.jpg";
import Step4 from "../../../static/images/steps/Step4.jpg";
import Step5 from "../../../static/images/steps/Step5.jpg";
import Step6 from "../../../static/images/steps/Step6.jpg";
import Step7 from "../../../static/images/steps/Step7.jpg";
import Step1Small from "../../../static/images/steps/Step1-small.jpg";
import Step2Small from "../../../static/images/steps/Step2-small.jpg";
import Step3Small from "../../../static/images/steps/Step3-small.jpg";
import Step4Small from "../../../static/images/steps/Step4-small.jpg";
import Step5Small from "../../../static/images/steps/Step5-small.jpg";
import Step6Small from "../../../static/images/steps/Step6-small.jpg";
import Step7Small from "../../../static/images/steps/Step7-small.jpg";

import styles from './StepsModal.module.scss';

type StepData = {
    image: string;
    text: string;
};

type StepsInfoProps = {
    slide: StepData;
    index: number;
    onClose: () => void;
};

type StepsModalProps = {
    open: boolean;
    handleClose: () => void;
    currentIndex: number;
};

const StepsInfo = ({slide, index, onClose}: StepsInfoProps) => {

    const onClick = (event: React.MouseEvent) => event.stopPropagation();

    return (
        <div className={styles.step} id={String(index + 1)} onClick={onClose}>
            <Row className={cx("justify-content-between align-items-center m-0")}>
                <Col xs={10} sm={9} xxl={{ span: 8, offset: 2 }} className="p-0" >
                    <h3 className={styles.title} onClick={onClick}>
                        Шаг {index + 1} из 7
                    </h3>
                    <br/>
                    <p className={styles.subtitle} onClick={onClick}>
                        {slide.text}.
                    </p>
                </Col>
            </Row>
            <Row className="m-0">
                <Col xxl={{ span: 10, offset: 2 }} className="p-0">
                    <div className={styles.stepInfoContainer}>
                        {index === 0 && (
                            <button className={styles.closeButton} onClick={onClose} type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <path d="M25.3332 8.54699L23.4532 6.66699L15.9998 14.1203L8.5465 6.66699L6.6665 8.54699L14.1198 16.0003L6.6665 23.4537L8.5465 25.3337L15.9998 17.8803L23.4532 25.3337L25.3332 23.4537L17.8798 16.0003L25.3332 8.54699Z" fill="currentColor" />
                                </svg>
                            </button>
                        )}
                        <div className={styles.browser}>
                            <ul className={styles.browserPanel}>
                                <li className={cx(styles.browserButton, styles.browserCloseButton)}/>
                                <li className={cx(styles.browserButton, styles.browserHideButton)}/>
                                <li className={cx(styles.browserButton, styles.browserExpandButton)}/>
                            </ul>
                        </div>
                        <img
                            src={slide.image}
                            alt={slide.text}
                            className={styles.slideImage}
                            draggable="false"
                            onClick={onClick}
                        />
                    </div>
                </Col>
            </Row>
        </div>
    );
}

const StepsModal = ({open, handleClose, currentIndex}: StepsModalProps) => {

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    useEffect(() => {
        if (open) {
            const timer = setTimeout(() => {
                const el = document.getElementById(String(currentIndex + 1));
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [open, currentIndex]);

    const slides = [
        { image: isMobile ? Step1Small: Step1, text: 'Создайте новый расчет доставки' },
        { image: isMobile ? Step2Small: Step2, text: 'Внесите данные по товарам и упаковке' },
        { image: isMobile ? Step3Small: Step3, text: 'Укажите данные по маршруту' },
        { image: isMobile ? Step4Small: Step4, text: 'Заполните данные по декларации' },
        { image: isMobile ? Step5Small: Step5, text: 'Выберите вариант сертификации' },
        { image: isMobile ? Step6Small: Step6, text: 'Укажите данные по счетам' },
        { image: isMobile ? Step7Small: Step7, text: 'Получите готовый расчет' },
    ];

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            <div className={styles.modal}>
                {slides.map((slide, index) => (
                    <StepsInfo slide={slide} key={index} index={index} onClose={handleClose}/>
                ))}
            </div>
        </Modal>
    );
}

export default StepsModal;
